import axios from 'axios';

const BACKEND_URL = window.location.origin;
const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true
});

export const teamAPI = {
  getAll: () => api.get('/teams'),
  create: (data) => api.post('/teams', data),
  getById: (id) => api.get(`/teams/${id}`),
  getMembers: (teamId) => api.get(`/teams/${teamId}/members`),
  inviteMember: (teamId, data) => api.post(`/teams/${teamId}/invite`, data)
};

export const appointmentAPI = {
  getAll: (teamId) => api.get(`/teams/${teamId}/appointments`),
  create: (teamId, data) => api.post(`/teams/${teamId}/appointments`, data)
};

export const taskAPI = {
  getAll: (teamId) => api.get(`/teams/${teamId}/tasks`),
  create: (teamId, data) => api.post(`/teams/${teamId}/tasks`, data),
  update: (teamId, taskId, data) => api.patch(`/teams/${teamId}/tasks/${taskId}`, data)
};

export const broadcastAPI = {
  getAll: (teamId) => api.get(`/teams/${teamId}/broadcasts`),
  create: (teamId, data) => api.post(`/teams/${teamId}/broadcasts`, data)
};

export const commentAPI = {
  getAll: (commentableType, commentableId) => 
    api.get(`/comments?commentable_type=${commentableType}&commentable_id=${commentableId}`),
  create: (data) => api.post('/comments', data)
};

export const shiftAPI = {
  getAll: (teamId) => api.get(`/teams/${teamId}/shifts`),
  create: (teamId, data) => api.post(`/teams/${teamId}/shifts`, data),
  claim: (shiftId) => api.post(`/shifts/${shiftId}/claim`),
  approve: (shiftId, assignmentId) => api.post(`/shifts/${shiftId}/assignments/${assignmentId}/approve`)
};

export const medicationAPI = {
  getAll: (teamId) => api.get(`/teams/${teamId}/medications`),
  create: (teamId, data) => api.post(`/teams/${teamId}/medications`, data),
  getLogs: (medicationId) => api.get(`/medications/${medicationId}/logs`),
  logMedication: (medicationId, data) => api.post(`/medications/${medicationId}/logs`, data)
};

export const careLogAPI = {
  getAll: (teamId) => api.get(`/teams/${teamId}/care-logs`),
  create: (teamId, data) => api.post(`/teams/${teamId}/care-logs`, data)
};

export const providerAPI = {
  getAll: (teamId) => api.get(`/teams/${teamId}/providers`),
  create: (teamId, data) => api.post(`/teams/${teamId}/providers`, data),
  getContacts: (providerId) => api.get(`/providers/${providerId}/contacts`),
  addContact: (providerId, data) => api.post(`/providers/${providerId}/contacts`, data),
  getLocations: (providerId) => api.get(`/providers/${providerId}/locations`),
  addLocation: (providerId, data) => api.post(`/providers/${providerId}/locations`, data)
};

export const mealTrainAPI = {
  getAll: (teamId) => api.get(`/teams/${teamId}/meal-trains`),
  create: (teamId, data) => api.post(`/teams/${teamId}/meal-trains`, data),
  getSlots: (mealTrainId) => api.get(`/meal-trains/${mealTrainId}/slots`),
  createSlot: (mealTrainId, data) => api.post(`/meal-trains/${mealTrainId}/slots`, data),
  claimSlot: (slotId) => api.patch(`/meal-slots/${slotId}/claim`)
};

export const expenseAPI = {
  getAll: (teamId) => api.get(`/teams/${teamId}/expenses`),
  create: (teamId, data) => api.post(`/teams/${teamId}/expenses`, data)
};

export const fundraiserAPI = {
  getAll: (teamId) => api.get(`/teams/${teamId}/fundraisers`),
  create: (teamId, data) => api.post(`/teams/${teamId}/fundraisers`, data),
  getDonations: (fundraiserId) => api.get(`/fundraisers/${fundraiserId}/donations`)
};

export const groceryListAPI = {
  getAll: (teamId) => api.get(`/teams/${teamId}/grocery-lists`),
  create: (teamId, data) => api.post(`/teams/${teamId}/grocery-lists`, data)
};

export const insuranceAPI = {
  getPolicies: (teamId) => api.get(`/teams/${teamId}/insurance-policies`),
  createPolicy: (teamId, data) => api.post(`/teams/${teamId}/insurance-policies`, data),
  getInteractions: (teamId) => api.get(`/teams/${teamId}/insurance-interactions`),
  createInteraction: (teamId, data) => api.post(`/teams/${teamId}/insurance-interactions`, data)
};

export const gratitudeAPI = {
  getAll: (teamId) => api.get(`/teams/${teamId}/gratitude`),
  create: (teamId, data) => api.post(`/teams/${teamId}/gratitude`, data)
};

export const planningAPI = {
  getEndOfLifePreferences: (teamId) => api.get(`/teams/${teamId}/end-of-life-preferences`),
  saveEndOfLifePreferences: (teamId, data) => api.post(`/teams/${teamId}/end-of-life-preferences`, data),
  getMemorialPlanning: (teamId) => api.get(`/teams/${teamId}/memorial-planning`),
  saveMemorialPlanning: (teamId, data) => api.post(`/teams/${teamId}/memorial-planning`, data)
};

export const paymentAPI = {
  createCheckout: (data) => api.post('/payments/checkout', data),
  getCheckoutStatus: (sessionId) => api.get(`/payments/checkout/status/${sessionId}`),
  createDonationCheckout: (fundraiserId, amount, originUrl) => 
    api.post('/payments/donate', { fundraiser_id: fundraiserId, amount, origin_url: originUrl }),
  getMySubscription: () => api.get('/subscriptions/my-subscription')
};

export default api;